/*
    Extends javascript's and jquery's primitives
*/
define(
function() {

    String.prototype.capitalizeFirstLetter = function() {
        return this.charAt(0).toUpperCase() + this.slice(1);
    }

    String.prototype.uncapitalizeFirstLetter = function() {
        return this.charAt(0).toLowerCase() + this.slice(1);
    }

    String.prototype.unQuote = function (){
        return this.replace(/(^["'])|(["']$)/g, '').replace(/\\/gi,'');
    }

    $.fn.getCssContent = function() {
        if(this.css('content') && this.css('content').length > 4) {
            try {
                var data = JSON.parse(this.css('content').unQuote());
                return data;
            } catch (e) {
                return {};
            }
        }
    }

    $.fn.findTarget = function(selector) {
        if(selector.trim().substr(0,1)==='&') {
            return this.find(selector.trim().substr(1).trim());
        }
        else if(selector.trim().substr(0,1)==='+') {
            return this.next(selector.trim().substr(1).trim());
        }
        else if(selector.trim().substr(0,1)==='~') {
            return this.siblings(selector.trim().substr(1).trim());
        }
        else {
            return $(selector.trim());
        }
    };

    $.fn.getParams = function(namespace,defaults,order){

        if(!order) {var order = ['defaults','css','html']}
        if(!defaults){var defaults = {}}

        var allParams = {
            defaults: defaults,
            css: {},
            html: {}
        };
        var paramsToReturn = {};

        namespace = namespace.replace(/-/gi,'');

        /*default*/
        allParams['defaults'] = defaults;

        /*css*/
        if(this.css('content') && this.css('content').length > 4) {
            var data = this.getCssContent();
            for(var k in data) {
                if(k.substr(0,namespace.length).toLowerCase() === namespace.toLowerCase()) {
                    allParams['css'][k.substr(namespace.length).uncapitalizeFirstLetter()] = data[k]
                }
            }
        }

        /*html*/
        var data = this.data();
        for(var k in data) {
            if(k.substr(0,namespace.length).toLowerCase() === namespace.toLowerCase()) {
                allParams['html'][k.substr(namespace.length).uncapitalizeFirstLetter()] = data[k]
            }
        }

        /*order*/
        order.map(function(type){
            for(var k in allParams[type]) {
                paramsToReturn[k] = allParams[type][k];
            }
        })

        return paramsToReturn;
    }

});